<div
    class="creation-confirm-bar"
    role="region"
    aria-label="Confirmation de création"
    [style.--creation-confirm-bar-max-width]="maxWidth">
    <div class="creation-confirm-bar__inner">
        <p-button
            type="button"
            size="large"
            styleClass="w-full"
            [label]="loading ? loadingLabel : label"
            [icon]="loading ? undefined : icon"
            [loading]="loading"
            [disabled]="disabled || loading"
            (onClick)="confirm.emit()" />
    </div>
</div>
